export default __webpack_public_path__ + "static/LeituraTwo-BoldItalic-0eae9be8746ad86fe9b7e2c0250546e5.woff2";